import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const IrregularityEntireSite = ({ irregularity }) => {
  const { t } = useTranslation();
  return (
    <section className="irregularity-site">
      <h6 className="mb-3">{t('irregularities.entireSiteLabel')}</h6>
      <h5 className="mt-3 mb-2">{t('irregularities.instructions')}</h5>
      <div className="copy-text mt-2">{irregularity.irregularityType.instructions}</div>
    </section>
  );
};

IrregularityEntireSite.propTypes = {
  irregularity: PropTypes.shape({
    irregularityType: PropTypes.shape({
      instructions: PropTypes.string,
    }),
  }).isRequired,
};

export default IrregularityEntireSite;
